import { ModelUpdatableInterface } from '../interfaces/model-updatable.interface';
import { PartialType, PickType } from '@nestjs/swagger';
import { ModelDto } from './model.dto';

export class ModelUpdateDto
  extends PartialType(
    PickType(ModelDto, [
      'externalId',
      'name',
      'description',
      'garageFirst',
      'archived',
      'subdivisionId',
      'highCeiling',
      'screwInspection',
      'laborOnly',
      'stockingSpec',
      'active',
      'defaultTotalSquareFootage',
      'hasTrim',
      'hasInteriorOptions',
      'defaultInteriorOptionCost',
      'hasExteriorOptions',
      'defaultExteriorOptionCost',
      'hasTrimOptions',
      'defaultTrimOptionCost',
      'hasExteriorPaint',
      'defaultExteriorSidingPaintAmount',
    ]),
  )
  implements ModelUpdatableInterface {}
